import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangProvider } from "@/lib/lang";
import Landing from "@/pages/Landing";
import BlogPost from "@/pages/BlogPost";
import Recipes from "@/pages/Recipes";
import RecipeDetail from "@/pages/RecipeDetail";
import JoinTeam from "@/pages/JoinTeam";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AppLogin from "@/pages/app/AppLogin";
import AppShell from "@/pages/app/AppShell";
import AppHome from "@/pages/app/AppHome";
import ClientWeight from "@/pages/app/ClientWeight";
import ProfilePage from "@/pages/app/ProfilePage";
import DietitianClientDetail from "@/pages/app/DietitianClientDetail";
import OwnerTeam from "@/pages/app/OwnerTeam";
import { TemplatesRoute, ChatRoute } from "@/pages/app/RoleRoutes";

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/recipes" element={<Recipes />} />
          <Route path="/recipes/:slug" element={<RecipeDetail />} />
          <Route path="/join-team" element={<JoinTeam />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />

          <Route path="/app/login" element={<AppLogin />} />
          <Route path="/app" element={<AppShell />}>
            <Route index element={<AppHome />} />
            <Route path="weight" element={<ClientWeight />} />
            <Route path="chat" element={<ChatRoute />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="templates" element={<TemplatesRoute />} />
            <Route path="team" element={<OwnerTeam />} />
            <Route path="client/:id" element={<DietitianClientDetail />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </LangProvider>
  );
}

export default App;
